import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setCategories} from "../../redux/actions/categories";
import axios from "axios/index";
import {API_URL} from "./../../config/Config";
import ReactLoading from "react-loading";
import {Badge, Button} from "reactstrap";

class CategoriesMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            currentParent:0,
            currentLevel:1,
            currentId:0,
            oldId:0,
            catItems:[],
            oldParent:''
        };

    }
    async componentDidMount(){
        if (!this.props.categories.isFetching){
            await this.handleRequest();
        }
        await this.getCurrentLevelCat(0);
        this.setState({loading: true});
    }

    getCurrentLevelCat(i){
        const catItems = this.props.categories.items.filter(cat =>parseInt(cat.parent_id, 10) === i);
        this.setState({catItems});
    }

    async handleRequest() {
        let response = await axios.get(`${API_URL}category`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');
        }else{
            let categories = response.data.data;
            this.props.setCategories(categories);
        }
        console.log("done");

    };
    handleClick (id){
        const {currentLevel,currentId} = this.state;
        const categories = this.props.categories.items;
        let clickedItem = categories[id];
        console.log(clickedItem.id);

        if (currentLevel === 1){
            this.setState({
                currentLevel: 2,
                currentId: clickedItem.id,
                currentParent: clickedItem.id,
                oldId: currentId,
                oldParent: clickedItem.name,
            });
            this.getCurrentLevelCat(clickedItem.id);
        }else{
            this.setState({
                currentLevel: 3,
                currentId: clickedItem.id,
            });
        }
        this.props.getBusiness(clickedItem.id);
    }
    handleBack(){
        this.setState({
            currentLevel: 1,
            currentId: this.state.oldId,
            oldId: 0,
            currentParent: 0,
        });
        this.getCurrentLevelCat(this.state.oldId);
        this.props.getBusiness(0);
    }
    handleBack2(){
        this.setState({
            currentLevel: 2,
            currentId: this.state.currentParent,
        });
        this.props.getBusiness(this.state.oldId);
    }

    render() {
        const {loading,currentLevel,catItems} = this.state;
        // const categories = this.props.categories.items;
        let levelName = 'سطح دوم : '+this.state.oldParent;
        if (currentLevel === 1){
            levelName = 'سطح اول';
        }


        return (
            <div className="clear-fx white rtl p-2">
                {!loading ? <div className="mt-2 mb-2 flex-center"><ReactLoading type="spinningBubbles" color="#4fbfa8"/></div> :

                    <div>
                        {(currentLevel !== 1)?
                            <Button color="link" className="back-btn" onClick={this.handleBack.bind(this)}>
                                <i className="fa fa-arrow-circle-right"/><span> بازگشت</span>
                            </Button>:""}

                            <h4 className="cat-menu-header">
                                {(currentLevel === 3)?
                                    <Button color="link" className="back2-btn" onClick={this.handleBack2.bind(this)}><i className="fa fa-step-forward"/></Button>:
                                   ""}
                                {levelName}
                            </h4>

                        {catItems.map(catItem =>
                        <Button color="link" key={catItem.id} className={(this.state.currentId === catItem.id)? "active category-btn":"category-btn"} onClick={this.handleClick.bind(this , catItem.id)}>
                            {catItem.name} <Badge color="default">{catItem.business_no}</Badge>  {(this.state.currentId === catItem.id)?<i className="fa fa-arrow-circle-down"/>:''}
                        </Button>
                    )}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        categories: state.categories,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setCategories : categories => {
            dispatch(setCategories(categories))
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(CategoriesMenu);



// WEBPACK FOOTER //
// ./src/components/merchants/CategoriesMenu.js